type Props = {
  balance: number
  paymentType: string
  creditLimit: number
}

const WARNING_THRESHOLD = 3000

const UserBalanceCell = ({balance, paymentType, creditLimit}: Props) => {
  let isWarning = false

  if (paymentType === '0') {
    // Prepaid
    isWarning = balance < WARNING_THRESHOLD
  }

  if (paymentType === '1') {
    // Postpaid
    const gap = balance - creditLimit
    isWarning = gap < WARNING_THRESHOLD
  }

  return <span className={`${isWarning ? 'text-warning' : 'text-gray-600'}`}>{balance}</span>
}

export default UserBalanceCell
